import { toast } from "react-toastify";
import * as Types from "./ApiEndpoint.types";
import { TokenRequestOptions } from "./ApiClient.types";
import { HttpError } from "./HttpError";
import { JwtResponse } from "../types";
import { Application } from "../interfaces";

export class ApiEndpoint {
  public endpoint: string;  
    public tokenOptions: TokenRequestOptions;
    public application: Application;
    public jwtResponse?: JwtResponse;
    public constructor(
        endpoint: string,
        tokenOptions: TokenRequestOptions,
        application: Application,
        jwtResponse?: JwtResponse
    ) {
        this.endpoint = endpoint;
        this.tokenOptions = tokenOptions;
        this.application = application;
        this.jwtResponse = jwtResponse;
    }   

  makeQuery = (query: string): ApiEndpoint => {
    let result = this.endpoint;
    if (result.indexOf("?") === -1) result += "?"; // Add ? if no queries exist
    if (!result.endsWith("?")) result += "&"; // prepend & if other queries exist
    result += query;

      return new ApiEndpoint(result, this.tokenOptions, this.application, this.jwtResponse);
  };

  /* Request functions */

    delete = (body?: object | string): Promise<Types.FetchResponse<any>> => {
    const options: Types.RequestOptions = {
      body: toJson(body ?? ""),
      method: "delete",
      headers: getHeaders({ contentType: "application/json" }),
    };

    return this.request(options);
  };

  get = (
    consistencyLevel?: Types.ConsistencyLevel
  ): Promise<Types.FetchResponse<any>> => {
    const options: Types.RequestOptions = {
      method: "get",
      headers: getHeaders({ consistencyLevel: consistencyLevel }),
    };

    return this.request(options);
  };

  post = (
    body: Object | FormData | string
  ): Promise<Types.FetchResponse<any>> => {
    const options: Types.RequestOptions = {
      body: toJson(body),
      method: "post",
      headers: getHeaders({ contentType: "application/json" }),
    };

    return this.request(options);
  };

  put = (
    body: Object | FormData | string
  ): Promise<Types.FetchResponse<any>> => {
    const options: Types.RequestOptions = {
      body: toJson(body),
      method: "put",
      headers: getHeaders({ contentType: "application/json" }),
    };

    return this.request(options);
  };

  request = async (options: Types.RequestOptions) => {
    //const r = await this.getToken();
    //  console.log("apirequest:: " + this.jwtResponse?.token);
      options.headers.append("Authorization", `Bearer ${this.jwtResponse?.token}`);
      //console.log(this.jwtResponse.Token);
    return await request(this.url(), options);
  };

  /* Query modifiers */
  count = () => this.makeQuery("$count=true");
  filter = (query: string) => this.makeQuery(`$filter=${query}`);
  orderBy = (fields: string) => this.makeQuery(`$orderby=${fields}`);
  search = (field: string, value: string) =>
    this.makeQuery(`$search="${field}:${value}"`);
  // select = (fields: string) => this.makeQuery(`$select=${fields.replaceAll(/\s/g, "")}`); // Replaced with below to be able to target es2017.
  select = (fields: string) =>
    this.makeQuery(`$select=${fields.replace(/\s/g, "")}`);
  top = (count: number) => this.makeQuery(`$top=${count}`);
  url = () => `${this.tokenOptions.baseUrl}/${this.endpoint}`;
}

export const toJson = (body: Object | FormData | string): string => {
  let data: string;

  // If FormData, convert to object before stringifying.
  if (body instanceof FormData) {
    const obj = formDataToObject(body);
    data = JSON.stringify(obj);
    // console.log("Object", obj);
    // console.log("Object stringified", data);
  } else if (body instanceof Object) {
    data = JSON.stringify(body);
    // console.log("PostJson Object type detected");
    // console.log("Object", body);
    // console.log("Object stringified", data);
  } else {
    data = body;
    // console.log("PostJson string type detected");
    // console.log("Object", body);
  }

  return data;
};

export const getHeaders = (props: Types.HeaderOptions): Headers => {
  const headers = new Headers();
    //headers.append("Access-Control-Allow-Origin", "*");
  if (props.consistencyLevel)
    headers.append("ConsistencyLevel", props.consistencyLevel);
  if (props.contentType) headers.append("Content-Type", props.contentType);

  return headers;
};

export const formDataToObject = (data: FormData): Object => {
  const entries = data.entries();
  let obj: any = {};

  for (let entry of entries) {
    const key = entry[0];
    const val = entry[1];

    // Check if key includes a dot, which indicates it's an object, not a string.
    if (key.includes(".")) {
      let k = key.split(".");
      let objKey = k[0];
      let innerKey = k[1];
      obj[objKey] = { ...obj[objKey], [innerKey]: val };
    } else {
      obj[key] = val;
    }

    console.log(key, val);
  }

  return obj;
};

// TODO: Implement eventhandler for different status codes.
export const request = async (
  url: string,
  options: Types.RequestOptions
): Promise<Types.FetchResponse<any>> => {
  try {
    // Make request
    const response = await fetch(url, options);
    //console.log("RESPONSE", response);

    if (response.status === 400) toast.error("400 error received", {autoClose: 2000});

    // Create the output variable.
    let output: Types.FetchResponse<any> = response;

    // if response indicates error, populate error property with body text.
    if (response.status > 300) {
      let error = response as ErrorResponse;
      // throw new HttpError(response);
      toast.error(error.error , {autoClose: 2000});
    } else {
      // Populate data property from json stream.
      output.data = await response.json();
    }

    // Return the output variable.
    return output;
  } catch (error) {
      if (error instanceof HttpError) {
        toast.error(`Html Error - ${error.status}  Error - ${error.message}` , {autoClose: 2000});
          console.log(`Html Error - ${error.status}`);
          console.log("Error", error.message);          
      }
      throw error;
  }
};

// TODO : Add handlers for each status type
export const ErrorHandler = async (statusCode: number) => {};

export default ApiEndpoint;

export type ErrorResponse = Response & {
  error?: string;
};

class RefreshToken {
    public Token: string;
    public refreshToken?: string

    public constructor(token: string, refreshToken?: string) {
        this.Token = token;
        this.refreshToken = refreshToken;
    }
};

class AccessToken {
    public AppGuid: string;
    public AppName: string;
    public UserEmail: string;

    public constructor(appGuid: string, appName: string, userEmail: string) {
        this.AppGuid = appGuid;
        this.AppName = appName;
        this.UserEmail = userEmail;
    }
};
